<template>
  <!-- 日期选择 -->
  <div @click="setEditIndex(index)">
    <el-row :gutter="10" style="margin-left: 5px">
      <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
        {{number}}
      </el-col>
      <el-col
        :xs="15"
        :sm="15"
        :md="15"
        :lg="15"
        :xl="15"
        class="item_container_title"
      >
        <el-input
          placeholder="请输入题目内容"
          @focus="showAdvance"
          @blur="updateQuestion()"
          v-model="question.questionsName"
          autosize
        ></el-input>
      </el-col>
      <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
        <i
          class="el-icon-delete delete"
          v-if="index == editIndex"
          @click="questiondel(question.id)"
        ></i>
        <el-badge 
          v-if="question.displayscriptcount || question.jumpscriptcount" 
          :value="question.displayscriptcount + question.jumpscriptcount" 
          class="item">
          <i
            class="el-icon-share"
            @click="()=>$emit('jumpshow',question.id)"
          ></i>
        </el-badge>
        <i class="el-icon-rank item drag-handle"></i>
      </el-col>
    </el-row>

    <el-row
      :gutter="10"
      style="margin-top: 12px !important"
      v-for="(childItem, childindex) in question.optionList"
      :key="index + '_' + childindex"
    >
      <div @click="setEditOptionIndex(childindex)">
        <!-- 11.24修改 date  题库不显示时间   预览显示-->
        <div style="margin-left: 50px">
          <fake-input
              class="inputvalue"
              :style="{ height: question.inputBoxSize + 'px' ,lineHeight: question.inputBoxSize + 'px' ,}"
              style="
                border: 1px solid #ccc !important;
                width: 400px;
                border-radius: 3px;
              "
              placeholder="选择日期"
            />
        </div>
      </div>
    </el-row>
    <!-- <el-row :gutter="10" style="margin-top: 12px !important;" v-if="index==editIndex">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                <span style="color: #FFF;">占</span>
            </el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16"
                    class="el_item_option item_container_title">
                <i class="el-icon-plus el-icon-common" @click="wjaddquestionoption(question.optionList,question,0)">添加选项</i>
                <i class="el-icon-s-fold el-icon-common"
                   @click="wjaddquestionoption(question.optionList,question,2)">批量添加</i>
                <i class="el-icon-menu el-icon-common"
                   @click="wjaddquestionoption(question.optionList,question,1)">添加【其他】</i>
            </el-col>
        </el-row> -->
  </div>
</template>
<script>
import FakeInput from './FakeInput.vue';
export default {
  components:{
    FakeInput
  },
  data() {
    return {
      editOptionIndex: "0_0",
      value: "",
    };
  },
  props: {
	  number: { type: Number, default: 0 },
    question: {},
    editIndex: { type: Number, default: 0 },
    isExistPage: { type: Boolean, default: false },
    index: { type: Number, default: 0 },
  },
  methods: {
    wjupdoption(item) {
      this.$emit("wjupdoption", item);
    },
    updateQuestion() {
      this.$emit("wjupdquestionoption", this.question);
    },
    wjaddquestionoption(optionList, item, type = 1) {
      this.$emit("wjaddquestionoption", optionList, item, type);
    },
    showAdvance(e) {
      this.$emit("showAdvance", e);
    },
    setEditIndex(index) {
      this.$emit("setEditIndex", index);
    },
    setEditOptionIndex(childIndex) {
      this.editOptionIndex = this.editIndex + "_" + childIndex;
    },
    wjdelquestionoption(options, item, childindex) {
      this.$emit("wjdelquestionoption", options, item, childindex);
    },
    questiondel(id) {
      this.$emit("questiondel", id);
    },
  },
  created() {},
};
</script>

<style scoped>
.el-date-editor {
  width: 80%;
  height: 40px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}
/deep/.el-input__prefix i {
  color: #ccc;
}
/deep/.el-input__suffix {
  display: none !important;
}
.delete,.item {
  font-size: 22px !important;
  line-height: 40px !important;
  margin-right: 30px !important;
  text-align: right;
  float: right;
  cursor: pointer;
}
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
.el_item_option {
  line-height: 40px;
  height: 44px;
}

.el-icon-common {
  margin-right: 23px;
  font-size: 16px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.el-icon-common-option {
  margin-left: 10px;
  font-size: 22px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.askxh {
  line-height: 40px;
  text-align: right;
}

.item_container_title {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.item_container_title:hover {
  //border: 1px darkgrey dashed;
}
</style>
